import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { Warning } from '@mui/icons-material';
function ConfirmDialog({
    title,
    description,
    state,
    handleClose,
    goAction,
    buttonColor = "error",
    confirmText = "OK",
    cancelText = "Cancelar",
    isLoading = false,
    icon
}) {
    return (
        <Dialog
            open={state}
            onClose={() => handleClose(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title" display={'flex'} gap={2} alignItems={'center'}>
              {icon ? icon : ''} {title}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {description}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => handleClose(false)} variant='outlined' disabled={isLoading}>
                    {cancelText}
                </Button>
                <Button
                    color={buttonColor}
                    onClick={() => goAction(true)}
                    autoFocus
                    variant="contained"
                    disabled={isLoading}
                >
                    {confirmText}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default ConfirmDialog;
